import { h } from "preact";

import IconProps from "./IconProps";

function IconMenu({ color, width, height, class: cssClass }: IconProps) {
    return (
        <svg class={cssClass} width={width} height={height} viewBox="0 0 24 24">
            <g fill={color} fill-rule="evenodd">
                <circle cx="6" cy="12" r="2"/>
                <circle cx="12" cy="12" r="2"/>
                <circle cx="18" cy="12" r="2"/>
            </g>
        </svg>
    );
}

IconMenu.defaultProps = {
    color: "var(--teflon)",
    width: 24,
    height: 24
};

export default IconMenu;
